import SelectableToolCard, { type IToolData } from 'components/NewSelectableToolCard/SelectableToolCard';
import { type IEmployeeAvailableTool } from 'types/services';
import { isEmployeeAvailableToolForOffboardingOriginList } from 'utils/logisticServiceOriginDestination.utils';

import './EmployeeOriginAvailableToolsList.scss';

interface IEmployeeOriginAvailableToolsListProps {
  employeeDisplayName: string;
  tools: IEmployeeAvailableTool[];
  productIdsAlreadyInService: Set<number>;
  selectedAssignmentIds: Set<string>;
  onToggleAssignment: (assignmentKey: string) => void;
}

const EmployeeOriginAvailableToolsList = ({
  employeeDisplayName,
  tools,
  productIdsAlreadyInService,
  selectedAssignmentIds,
  onToggleAssignment
}: IEmployeeOriginAvailableToolsListProps) => {
  const headingText = `Herramientas que tiene ${employeeDisplayName} disponible`

  const renderPills = (pills: { [key: string]: string | null }): { [key: string]: string | null } => {
    if (pills) {
      Object.entries(pills).forEach(([key, value], index) => {
        if (value) {
          return { key: `${key}-${index}`, value };
        }
      });
    }
    return {};
  };

  const mapToSelectableTool = (item: IEmployeeAvailableTool): IToolData => {
    const serialRaw = item.serial?.trim() || item.sku?.trim() || `product-${item.productId}`;
    const displaySerial =
      serialRaw.length > 32 ? `${serialRaw.slice(0, 22)}…` : serialRaw;

    return {
      id: item.productId,
      productId: item.productId,
      name: item.productName,
      image: item.image ?? undefined,
      brand: item.brand ?? undefined,
      brandImage: item.brandImage ?? undefined,
      serial: displaySerial,
      pills: renderPills(item?.pills ?? {})
    };
  };

  const assignmentKey = (item: IEmployeeAvailableTool) => String(item.assignmentId);

  const visibleTools = tools?.filter(
    item =>
      isEmployeeAvailableToolForOffboardingOriginList(item) && !productIdsAlreadyInService.has(item.productId)
  );

  if (!visibleTools.length) {
    return null;
  }

  return (
    <div className="employeeOriginAvailableToolsList">
      <div className="employeeOriginAvailableToolsDivider" />
      <h2 className="employeeOriginAvailableToolsTitle">{headingText}</h2>
      <div className="employeeOriginAvailableToolsCards">
        {visibleTools?.map(item => {
          const mapped = mapToSelectableTool(item);
          const key = assignmentKey(item);
          const isSelected = selectedAssignmentIds.has(key);

          return (
            <SelectableToolCard
              key={key}
              tool={mapped}
              showCheckbox
              isSelected={isSelected}
              onSelectionChange={() => onToggleAssignment(key)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EmployeeOriginAvailableToolsList;
